import React, { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DoneIcon from "@mui/icons-material/Done";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import "./FormSubmissionSuccessDialog.scss";

const FormSubmissionSuccessDialog = ({
  open,
  onClose,
  title,
  eyebrow = "Request submitted",
  message,
  trackingId,
  trackingLabel = "Tracking ID",
  children,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!trackingId) return;
    try {
      await navigator.clipboard.writeText(String(trackingId));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="form-submit-success-dialog"
      fullWidth
      maxWidth="sm"
      PaperProps={{ className: "form-submit-success-dialog__paper" }}
    >
      <DialogContent className="form-submit-success-dialog__content">
        <div className="form-submit-success-dialog__icon-wrap">
          <DoneIcon className="form-submit-success-dialog__icon" />
        </div>
        <p className="form-submit-success-dialog__eyebrow">{eyebrow}</p>
        <Typography component="h2" className="form-submit-success-dialog__title">
          {title}
        </Typography>
        {message ? (
          <p className="form-submit-success-dialog__message">{message}</p>
        ) : null}
        {trackingId ? (
          <div className="form-submit-success-dialog__id-box">
            <div className="form-submit-success-dialog__id-text">
              <span className="form-submit-success-dialog__id-label">
                {trackingLabel}
              </span>
              <p className="form-submit-success-dialog__id-value">
                {trackingId}
              </p>
            </div>
            <Tooltip title={copied ? "Copied!" : "Copy"}>
              <IconButton
                type="button"
                className="form-submit-success-dialog__copy-btn"
                onClick={handleCopy}
                aria-label="Copy tracking ID"
                size="small"
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        ) : null}
        {children ? (
          <div className="form-submit-success-dialog__extra">{children}</div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default FormSubmissionSuccessDialog;
